import React, { useEffect } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const ErrorModal = ({ title = 'Error', message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3200);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/85 px-4 py-6 backdrop-blur-sm">
      <div className="relative w-full max-w-lg overflow-hidden rounded-[32px] border border-white/10 bg-white/95 p-6 shadow-2xl shadow-slate-900/25">
        <div className="absolute inset-x-0 top-0 h-2 bg-gradient-to-r from-red-500 via-orange-400 to-red-500" />
        <div className="relative pt-6 text-center">
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-red-600/15 text-red-700 shadow-lg shadow-red-500/20">
            <FiAlertTriangle className="h-11 w-11" />
          </div>
          <h3 className="mt-5 text-3xl font-semibold text-slate-900">{title}</h3>
          <p className="mx-auto mt-3 max-w-xs text-sm leading-7 text-slate-600">{message}</p>
        </div>

        <div className="mt-8 flex justify-center">
          <button
            onClick={onClose}
            className="inline-flex items-center justify-center rounded-full bg-red-600 px-6 py-3 text-sm font-semibold text-white shadow-xl shadow-red-600/20 transition hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500/30"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
